import { compose } from "redux";
import classNames from "classnames";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";

import { WorkDayMapper } from "features/planner/planner.mappers";
import { WORK_SCHEDULE_STATUS } from "features/planner/planner.constants";
import WorkScheduleReportItem from "features/planner/report/workSchedule/components/WorkScheduleReportItem";
import WorkScheduleReportFlexDays from "features/planner/report/workSchedule/components/WorkScheduleReportFlexDays";

class WorkScheduleMonthReportWorkDayWeek extends PureComponent {
  render() {
    const {
      status,
      classes,
      flexDayCount,
      title,
      children,
      TooltipProps,
    } = this.props;

    return (
      <WorkScheduleReportItem
        title={title}
        TooltipProps={TooltipProps}
        classes={{
          root: classNames(classes.root, {
            [classes.workDayOff]: [
              WORK_SCHEDULE_STATUS.OFF,
              WORK_SCHEDULE_STATUS.OFF_FLEX,
            ].includes(status),
          }),
        }}
      >
        <WorkScheduleReportFlexDays count={flexDayCount} />
        {children}
      </WorkScheduleReportItem>
    );
  }
}

WorkScheduleMonthReportWorkDayWeek.defaultProps = {
  title: "",
  flexDayCount: 0,
  workDay: WorkDayMapper.initial(),
};

const styles = theme => ({
  root: {
    background: theme.palette.grey[50],
    "&:hover": {
      background: theme.altus.calendar.workdayOffColor.hover,
    },
  },
  workDayOff: {
    background: theme.altus.calendar.workdayOffColor.main,
  },
});

export default compose(withStyles(styles))(WorkScheduleMonthReportWorkDayWeek);
